import { getLocale } from "../runtime";

const sv_ingredients = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Ingredienser`
};

const ingredients = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_ingredients(inputs)
	return "ingredients";
};

export { ingredients as "ingredients" };